import { render, staticRenderFns } from "./TriviaModeForm.vue?vue&type=template&id=7b5bd710&scoped=true&"
import script from "./TriviaModeForm.vue?vue&type=script&lang=ts&"
export * from "./TriviaModeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5bd710",
  null
  
)

export default component.exports